import { Link } from "react-router-dom";
import { MdOutlineStorefront } from "react-icons/md";
import { FiExternalLink } from "react-icons/fi";
import UserDataFetcher from "../../../libs/getUserbyUserId";
import useBusinessMerchant from "../../../Routes/Marketplace/Merchant/lib/fetchBusinessMerchant";
import { getMerchantStorePath } from "../../../Routes/Marketplace/libs/marketplaceRoutes";
import PageHeader from "../../components/PageHeader";
import DetailGrid from "../../components/DetailGrid";

const MerchantStorePage = () => {
  const { userData } = UserDataFetcher();
  const { data: businessData, isLoading } = useBusinessMerchant();
  const user = userData?.user;
  const merchant = businessData?.merchant;
  const merchantId = user?.userId || user?._id;
  const publicStoreUrl = merchantId ? getMerchantStorePath(merchantId) : null;

  return (
    <>
      <PageHeader title="Store" subtitle="Your public storefront and seller profile" icon={MdOutlineStorefront} />
      <div className="dashboard-card">
        {isLoading ? (
          <p>Loading store info…</p>
        ) : (
          <>
            <h2 className="dashboard-card__title">Store profile</h2>
            <DetailGrid
              items={[
                { label: "Business name", value: merchant?.businessName || "—" },
                { label: "Category", value: merchant?.businessCategory || "—" },
                {
                  label: "Location",
                  value: [merchant?.city, merchant?.state].filter(Boolean).join(", ") || "—",
                },
                {
                  label: "Verification",
                  value: user?.isInfoVerify ? "Verified" : "Pending review",
                },
              ]}
            />
            {merchant?.businessDescription && (
              <p className="dashboard-form-hint" style={{ marginTop: 16 }}>
                {merchant.businessDescription}
              </p>
            )}
            {(merchant?.returnsAndRefundsPolicy || merchant?.customerSupportInformation) && (
              <div style={{ marginTop: 20 }}>
                {merchant.returnsAndRefundsPolicy && (
                  <>
                    <h3 className="dashboard-card__title">Returns & refunds</h3>
                    <p className="dashboard-form-hint">{merchant.returnsAndRefundsPolicy}</p>
                  </>
                )}
                {merchant.customerSupportInformation && (
                  <>
                    <h3 className="dashboard-card__title" style={{ marginTop: 16 }}>Customer support</h3>
                    <p className="dashboard-form-hint">{merchant.customerSupportInformation}</p>
                  </>
                )}
              </div>
            )}
            <div style={{ marginTop: 24, display: "flex", gap: 12, flexWrap: "wrap" }}>
              {publicStoreUrl && (
                <Link to={publicStoreUrl} className="dashboard-btn dashboard-btn--primary" target="_blank" rel="noreferrer">
                  <FiExternalLink aria-hidden="true" /> View public store
                </Link>
              )}
              <Link to="/merchant/account" className="dashboard-btn dashboard-btn--secondary">
                Edit business info
              </Link>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default MerchantStorePage;
